import * as Sentry from "@sentry/react";


export const initializeSentry = () => {
    Sentry.init({
        dsn: "https://58eda1c09e9cffc04f4ec611729f6a5e@o4509408481574912.ingest.de.sentry.io/4509408483999824",
        // Setting this option to true will send default PII data to Sentry.
        // For example, automatic IP address collection on events
        sendDefaultPii: true,
        // Enable source maps
        integrations: [],
        // This sets the release version
        release: import.meta.env.VITE_APP_VERSION || 'development',
        environment: import.meta.env.MODE
    });
};
